<template>
  <v-card class="elevation-0 pa-0" width="480" max-width="480" outlined>
    <v-toolbar flat color="secondary">
      <v-toolbar-title class="white--text">{{ modeTitle }}</v-toolbar-title>
    </v-toolbar>
    <v-container class="pl-4 ma-0">
      <v-img max-width="200" src="../assets/logo.png"></v-img>
    </v-container>
    <v-container>
      <v-form @submit.prevent="submitForm" ref="loginForm">
        <template v-for="(item, key, i) in formFields">
          <v-text-field
            v-if="item.modes.includes(mode)"
            v-model="item.value"
            :id="key"
            placeholder=" "
            outlined
            :key="i"
            :label="item.name"
            :type="item.type"
            :rules="item.rules"
            :autocomplete="item.disableAutoComplete ? 'new-password' : ''"
          ></v-text-field>
        </template>
        <slot name="details"></slot>
        <v-card-actions class="py-0 px-0">
          <slot name="buttons"></slot>
          <v-spacer></v-spacer>
          <v-btn elevation="0" color="primary" type="submit">{{ modeTitle }}</v-btn>
        </v-card-actions>
      </v-form>
    </v-container>
    <div
      v-if="message.content"
      :style="{color: message.color}"
      class="text-center"
    >{{ message.content }}</div>
    <div
      v-if="response.content"
      :style="{color: response.color}"
      class="text-center"
    >{{ response.content }}</div>
    <div class="py-2 px-4 text-center text--secondary">
      <small>
        If you are having trouble, please contact support at
        <a
          class="text-decoration-none"
          href="mailto:support@beyondlabz.com"
        >support@beyondlabz.com</a>
      </small>
    </div>
    <div class="text--disabled text-center">
      <small>&copy; Beyond Labz {{ new Date().getFullYear() }}</small>
    </div>
  </v-card>
</template>

<script>
import LoginFormFields from './LoginFormFields';

export default {
  name: 'LoginForm',
  props: ['mode', 'response'],
  data: () => ({
    formFields: LoginFormFields(),
    modeOptions: {
      login: {
        title: 'Login',
        fields: {
          username: 'username',
          password: 'password',
        },
      },
      register: {
        title: 'Register',
        fields: {
          username: 'username',
          nickname: 'nickname',
          password: 'confirmPassword',
        },
      },
      forgot: {
        title: 'Reset Password',
        fields: {
          username: 'username',
        },
      },
      update: {
        title: 'Change Password',
        fields: {
          password: 'confirmPassword',
        },
      },
      reset: {
        title: 'Enter New Password',
        fields: {
          password: 'confirmPassword',
        },
      },
    },
    message: {
      content: '',
      color: 'red',
    },
  }),
  computed: {
    modeTitle() {
      return this.modeOptions[this.mode].title || '';
    },
  },
  watch: {
    // eslint-disable-next-line
    'formFields.username.value': function () {
      this.message.content = '';
    },
    // eslint-disable-next-line
    'formFields.nickname.value': function () {
      this.message.content = '';
    },
    // eslint-disable-next-line
    'formFields.password.value': function () {
      this.message.content = '';
    },
    // eslint-disable-next-line
    'formFields.newPassword.value': function () {
      this.message.content = '';
    },
    // eslint-disable-next-line
    'formFields.confirmPassword.value': function () {
      this.message.content = '';
    },
  },
  methods: {
    submitForm() {
      if (this.$refs.loginForm.validate()) {
        const options = this.modeOptions[this.mode];
        const data = {};
        Object.entries(options.fields).forEach(([key, value]) => {
          data[key] = this.formFields[value].value;
        });
        console.log('//** This is the submit method', data);
        this.$emit('form-submitted', data);
      } else {
        this.message.content = 'There are invalid entries in your form.';
      }
    },
  },
};
</script>
